import PropTypes                   from 'prop-types'
import React                       from 'react'
import { Link                    } from 'react-router-dom'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'

import { NavLink } from 'alto-react-components/lib/components'

import { generalRegistrationSetting } from './settings'

export link = (route) -> ({ children }) -> <Link to={route}>{children}</Link>

export prefix                = '/auth'
export login                 = prefix + '/login'
export registration          = prefix + '/registration'
export initPasswordReset     = prefix + '/init_password_reset'
export confirmPasswordReset  = prefix + '/confirm_password_reset'
export resendActivationEmail = prefix + '/resend_activation_email'

export LoginLink                 = link(login)
export InitPasswordResetLink     = link(initPasswordReset)
export ResendActivationEmailLink = link(resendActivationEmail)

export LoginNavLink = ->
  <NavLink id="login-link" to={login}>Přihlásit</NavLink>

export registrationNavLinkTo = (props, context) ->
  registrationSetting = generalRegistrationSetting(context.settings)

  if registrationSetting.enabled
    <NavLink id="register-link" to={props.to}>
      Registrovat
    </NavLink>
  else
    tooltip =
      <Tooltip id='registration-disabled-tooltip'>
        {registrationSetting.disabledMessage}
      </Tooltip>

    <NavLink id="register-link" to={props.to} disabled>
      <OverlayTrigger placement='bottom' overlay={tooltip}>
        <span>Registrovat</span>
      </OverlayTrigger>
    </NavLink>

export RegisterNavLink = (props, context) ->
  registrationNavLinkTo({...props, to: registration}, context)

RegisterNavLink.contextTypes = { settings: PropTypes.object }
